import React from 'react';
import Icon from '../../../components/AppIcon';

const PasswordStrengthIndicator = ({ password }) => {
  const requirements = [
    { label: 'At least 8 characters', test: (pwd) => pwd.length >= 8 },
    { label: 'Contains uppercase letter', test: (pwd) => /[A-Z]/.test(pwd) },
    { label: 'Contains lowercase letter', test: (pwd) => /[a-z]/.test(pwd) },
    { label: 'Contains number', test: (pwd) => /\d/.test(pwd) },
    { label: 'Contains special character', test: (pwd) => /[!@#$%^&*(),.?":{}|<>]/.test(pwd) }
  ];

  const metRequirements = requirements.filter(req => req.test(password));
  const strength = metRequirements.length;

  const getStrengthColor = () => {
    if (strength <= 2) return 'bg-destructive';
    if (strength <= 3) return 'bg-warning';
    if (strength <= 4) return 'bg-secondary';
    return 'bg-success';
  };

  const getStrengthText = () => {
    if (strength <= 2) return 'Weak';
    if (strength <= 3) return 'Fair';
    if (strength <= 4) return 'Good';
    return 'Strong';
  };

  if (!password) return null;

  return (
    <div className="mt-3 space-y-3">
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Password Strength</span>
          <span className={`
            text-sm font-medium
            ${strength <= 2 ? 'text-destructive' : ''}
            ${strength === 3 ? 'text-warning' : ''}
            ${strength === 4 ? 'text-secondary' : ''}
            ${strength === 5 ? 'text-success' : ''}
          `}>
            {getStrengthText()}
          </span>
        </div>
        
        <div className="w-full bg-muted rounded-full h-2">
          <div
            className={`h-2 rounded-full transition-all duration-300 ease-out ${getStrengthColor()}`}
            style={{ width: `${(strength / 5) * 100}%` }}
          />
        </div>
      </div>

      <div className="space-y-1">
        {requirements.map((requirement, index) => {
          const isMet = requirement.test(password);
          return (
            <div key={index} className="flex items-center space-x-2">
              <Icon
                name={isMet ? "Check" : "X"}
                size={14}
                className={isMet ? 'text-success' : 'text-muted-foreground'}
              />
              <span className={`
                text-xs
                ${isMet ? 'text-success' : 'text-muted-foreground'}
              `}>
                {requirement.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PasswordStrengthIndicator;